import { GraduationCap, Users, Factory, Rocket, Landmark, HandCoins } from "lucide-react";

const NAVY = "#082F6B";
const GREEN = "#A5E34D";
const C = { x: 400, y: 292 };
const R = { x: 168, y: 184 };

// angle (deg), icon, label lines, label anchor side
const NODES = [
  { a: -90, Icon: GraduationCap, lines: ["Academic", "Institutions"], side: "top" },
  { a: -30, Icon: Factory, lines: ["Industry", "& Corporates"], side: "right" },
  { a: 30, Icon: Landmark, lines: ["Government &", "Public", "Institutions"], side: "right" },
  { a: 90, Icon: HandCoins, lines: ["Investors &", "Civil Society"], side: "bottom" },
  { a: 150, Icon: Rocket, lines: ["Startups &", "Entrepreneurs"], side: "left" },
  { a: 210, Icon: Users, lines: ["Researchers"], side: "left" },
].map((n) => {
  const rad = (n.a * Math.PI) / 180;
  return { ...n, cos: Math.cos(rad), sin: Math.sin(rad), x: C.x + R.x * Math.cos(rad), y: C.y + R.y * Math.sin(rad) };
});

const NODE_R = 48;
const CORE_R = 74;

const Label = ({ n }) => {
  const lh = 24;
  const pos = {
    top: { x: n.x, y: n.y - NODE_R - 14 - (n.lines.length - 1) * lh, anchor: "middle" },
    bottom: { x: n.x, y: n.y + NODE_R + 28, anchor: "middle" },
    right: { x: n.x + NODE_R + 16, y: n.y - ((n.lines.length - 1) * lh) / 2 + 6, anchor: "start" },
    left: { x: n.x - NODE_R - 16, y: n.y - ((n.lines.length - 1) * lh) / 2 + 6, anchor: "end" },
  }[n.side];
  return (
    <text x={pos.x} y={pos.y} textAnchor={pos.anchor} fill={NAVY} fontSize="21" fontWeight="700">
      {n.lines.map((l, i) => <tspan key={l} x={pos.x} dy={i ? lh : 0}>{l}</tspan>)}
    </text>
  );
};

export const EcosystemGraphic = ({ className = "" }) => (
  <svg viewBox="0 0 800 598" className={className} role="img" aria-labelledby="eco-title eco-desc" data-testid="about-ecosystem-graphic">
    <title id="eco-title">BRaIN ecosystem connectivity</title>
    <desc id="eco-desc">BRaIN at the centre, connected to six stakeholder groups: Academic Institutions, Researchers, Industry and Corporates, Startups and Entrepreneurs, Government and Public Institutions, and Investors and Civil Society.</desc>
    <ellipse cx={C.x} cy={C.y} rx={R.x} ry={R.y} fill="none" stroke={NAVY} strokeOpacity="0.28" strokeWidth="1.5" />
    {NODES.map((n) => {
      const sx = C.x + (CORE_R + 6) * n.cos, sy = C.y + (CORE_R + 6) * n.sin;
      const ex = n.x - (NODE_R + 8) * n.cos, ey = n.y - (NODE_R + 8) * n.sin;
      return (
        <g key={n.a}>
          <line x1={sx} y1={sy} x2={ex} y2={ey} stroke={NAVY} strokeOpacity="0.45" strokeWidth="1.2" strokeDasharray="3 4" />
          <circle cx={ex} cy={ey} r="5" fill={GREEN} />
        </g>
      );
    })}
    <circle cx={C.x} cy={C.y} r={CORE_R + 10} fill="#F1F5FB" />
    <circle cx={C.x} cy={C.y} r={CORE_R} fill="#FFFFFF" stroke={NAVY} strokeOpacity="0.5" strokeWidth="1.5" />
    <text x={C.x} y={C.y + 14} textAnchor="middle" fill={NAVY} fontSize="40" fontWeight="800" letterSpacing="-0.5">BRaIN</text>
    {NODES.map((n) => (
      <g key={`n${n.a}`}>
        <circle cx={n.x} cy={n.y} r={NODE_R + 6} fill="#F1F5FB" />
        <circle cx={n.x} cy={n.y} r={NODE_R} fill="#FFFFFF" stroke={NAVY} strokeOpacity="0.3" strokeWidth="1.5" />
        <n.Icon x={n.x - 19} y={n.y - 19} width="38" height="38" color={NAVY} strokeWidth={1.6} aria-hidden="true" />
        <Label n={n} />
      </g>
    ))}
  </svg>
);
